export const SET_App_USER_ROLE = "SET_App_USER_ROLE ";
export const GET_App_USER_ROLE = "GET_App_USER_ROLE ";
export const SET_ACTIVE_MENU = "SET_ACTIVE_MENU";
